// api/user.js
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import axios from "utils/axios";

export const useGetUser = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Get user from Redux store to trigger refetch when it changes
  const reduxUser = useSelector((state) => state.auth.user);

  const fetchUser = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      // Fetch user by ID
      const response = await axios.get(`/api/users/personal-info/`);
      setData(response.data);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch user data");
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch when component mounts
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  // Refetch when Redux user data changes (after profile updates)
  useEffect(() => {
    if (reduxUser) {
      fetchUser();
    }
  }, [reduxUser, fetchUser]);

  return {
    user: data,
    userLoading: loading,
    userError: error,
    refetchUser: fetchUser,
  };
};

export const useGetProfessional = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Get user from Redux store to trigger refetch when it changes
  const reduxUser = useSelector((state) => state.auth.user);

  const fetchUserProfessional = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      // Fetch professional by ID
      const response = await axios.get(`/api/users/professional-info/`);
      // console.log("professional", response.data)
      setData(response.data);
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to fetch professional data",
      );
      console.error("Error fetching user:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch when component mounts
  useEffect(() => {
    fetchUserProfessional();
  }, [fetchUserProfessional]);

  // Refetch when Redux user data changes (after profile updates)
  useEffect(() => {
    if (reduxUser) {
      fetchUserProfessional();
    }
  }, [reduxUser, fetchUserProfessional]);

  return {
    professional: data,
    professionalLoading: loading,
    professionalError: error,
    refetchProfessional: fetchUserProfessional,
  };
};
